import { Component, OnDestroy, OnInit } from '@angular/core'
import { AdminUsersService } from '../services/admin-users.service'
import { ActivatedRoute } from '@angular/router'
import { Subscription } from 'rxjs/Subscription'
import { UserModel } from '../../../models/user.model'
import { FormControl } from '@angular/forms'
import { FuseTranslationLoaderService } from '../../../../core/services/translation-loader.service'
import { userDutch } from '../../users/i18n/nl'
import { userEnglish } from '../../users/i18n/en'

@Component({
  selector: 'app-admin-users',
  templateUrl: './admin-users.component.html',
  styleUrls: ['./admin-users.component.scss'],
})
export class AdminUsersComponent implements OnInit, OnDestroy {
  searchInput: FormControl
  currentUser: UserModel
  onCurrentUserChanged: Subscription
  onSearchChanged: Subscription
  onUsersChanged: Subscription
  totalUsers: number
  administrationId: number

  constructor(private adminUsersService: AdminUsersService, private translationLoader: FuseTranslationLoaderService) {
    this.translationLoader.loadTranslations(userEnglish, userDutch)
    this.searchInput = new FormControl('')
  }

  ngOnInit() {
    this.onCurrentUserChanged = this.adminUsersService.onUserChanged.subscribe(user => {
      this.currentUser = user
    })

    this.onSearchChanged = this.searchInput.valueChanges
      .debounceTime(400)
      .distinctUntilChanged()
      .subscribe(searchText => {
        this.currentUser = undefined
        this.adminUsersService.changeSearch(searchText)
      })

    this.onUsersChanged = this.adminUsersService.onUsersChanged.subscribe(response => {
      this.totalUsers = response.total_results
    })
  }

  ngOnDestroy() {
    this.onCurrentUserChanged.unsubscribe()
    this.onSearchChanged.unsubscribe()
    this.onUsersChanged.unsubscribe()
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/ledger/admin-users/admin-users.component.ts